// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { initFirebase, watchAuth, signInWithGoogle, signOut } from '../firebaseClient';
const AuthContext = createContext({
  user: null,
  ready: false,
  signIn: () => {},
  signOutFn: () => {},
});
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    initFirebase({});
    const unsub = watchAuth((u) => {
      setUser(u || null);
      // 첫 auth 콜백이 도착한 시점 = 초기화 완료
      setReady(true);
    });
    return () => unsub && unsub();
  }, []);
  const value = {
    user,
    ready,
    signIn: signInWithGoogle,
    signOutFn: signOut,
  };
  // 초기화 전에는 실제 UI 렌더 X (스켈레톤/로더로 바꿔도 됨)
  if (!ready) return null;
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export function useAuth() {
  return useContext(AuthContext);
}
